export default __webpack_public_path__ + "static/media/image1.4efedf34.jpeg";